module.exports = __webpack_public_path__ + "static/media/15.59ba8a85.jpg";